import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Dropzone from 'react-dropzone';
import axios from 'axios';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import LinkPicker from './LinkPicker.js';
import PaddingPicker from './PaddingPicker.js';

import SidebarElementHeader from './SidebarElementHeader.js';
import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import AlignPicker from './AlignPicker.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';


class FileUpload extends React.Component {
	constructor(props) {	
		super(props);
		this.onOpenClick = this.onOpenClick.bind(this);
		this.renderIsUploading = this.renderIsUploading.bind(this);
		this.renderUpload = this.renderUpload.bind(this);
		this.onDrop = this.onDrop.bind(this);	
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
        this.onPaddingChange = this.onPaddingChange.bind(this);
        this.handleLinkChange = this.handleLinkChange.bind(this);

	}

	onDrop(files) {
        if(files.length == 0) {
            return;
        }

        this.setState({isUploading:true});

        let data = new FormData();
        data.append('file', files[0]);

        axios.post('/ajax/upload_image',data)
        .then(res => {
            this.props.setComponentState(this.el().id,{
                isUploading:false,
                image:res.data.url,
                original_width:res.data.original_width,
                original_height:res.data.original_height
            });
        }).catch(err => {
            this.setState({isUploading:false});
        });

		
return;
		this.props.setComponentState(this.el().id,{isUploading:true});
		let ret = '{"success":true,"message":"File uploaded","url":"http:\/\/cdn.crall.io\/dev-uploads\/3a944de9e086f9dff282d60ce24cde14.jpg","filename":"3a944de9e086f9dff282d60ce24cde14.jpg"}';
		ret = JSON.parse(ret);

		setTimeout(() => {
			this.doneUploading(ret);
		},1000);



    }

    onPaddingChange(id,padding) {
        let changes = {};
        changes[id] = padding;      
        this.props.setComponentState(this.el().id,changes);
    }



    onOpenClick() {
      this.refs.dropzone.open();
    }

    renderIsUploading() {
        if(this.props.sidebar == true) {
            return (<div className="state-is-uploading"><img src="/images/ajax.gif" /><br />Uploading..</div>
            );
        }
    	return (<td style={{textAlign:'center'}}>
    		<div className="state-is-uploading"><img src="/images/ajax.gif" /><br />Uploading..</div>
    		</td>
    	);
    }

    renderUpload() {
    	if(this.props.sidebar == true) {
    		return (
    			<div>
    				<SidebarElementSpacing text='Upload image' />
		    		<SidebarElementWrapper>
		    			<Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
		    				<button type="button" onClick={this.onOpenClick} className="btn btn-dark btn-block"><i className="icon wb-search" aria-hidden="true"></i> Browse</button>
		    			</Dropzone>
					</SidebarElementWrapper>
    			</div>
    		);
    	}
    	return (
            <td style={{textAlign:'center'}}>
    		<Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
				<div className="state-waiting-for-file">
					<img src="/images/builder/image.png" style={{width:'90px'}} /><br />
					Drop a file here<br />or<br />
					<button type="button" onClick={this.onOpenClick} className="btn btn-dark btn-sm"><i className="icon wb-search" aria-hidden="true"></i> Browse</button>
				</div>
			</Dropzone>
            </td>
		);
    }

    renderSidebarUpload() {
    	return (
    		<Dropzone ref="dropzone" style={{}} disableClick={true} multiple={false} onDrop={this.onDrop}>
				<button type="button" onClick={this.onOpenClick} className="btn btn-dark btn-sm"><i className="icon wb-search" aria-hidden="true"></i> Browse</button>
			</Dropzone>
		);
    }

    renderImage() {
	    let max = 600/(this.props.row_cols ? this.props.row_cols:1);

	    let w = max;

	    if(this.el().original_width < max) {
	        w = this.el().original_width;
        }

        if(w == 0) {
	        w = max;
        }

    	return (
            <td style={{textAlign:this.el().align,padding:this.el().padding}}>
                <div className="image">
                    <img src={this.el().image} style={{width:w}} />
                </div>
            </td>
        )
    }

    el() {
    	return this.props.builder.components[this.props.id];
    }

    removeImage(e) {
    	e.stopPropagation();
    	this.props.setComponentState(this.props.id,{image:false});
    }

    handleLinkChange(id,s) {
        this.props.setComponentState(this.el().id,s);
    }

    renderSettings() {

    	return (
    		<div className="panel-group panel-group-continuous" id="cart-settings" aria-multiselectable="true" role="tablist">

            <SidebarSettingAccordion selectedSetting={false} optionKey="image" parent="cart-settings" title="Image">
                <SidebarElementWrapper>
                    <button type="button" className="btn btn-dark btn-block" style={{marginBottom:'20px'}} onClick={(e) => { this.removeImage(e) }}>Remove image</button>
                </SidebarElementWrapper>

                <SidebarElementSetting text="Horizontal position">
                    <AlignPicker id="align" align={this.el().align} handleChange={this.onPaddingChange}/>
                </SidebarElementSetting>

                <SidebarElementSetting text="Padding">
                    <PaddingPicker id='padding' handlePaddingChange={this.onPaddingChange} data={this.el().padding} />
                </SidebarElementSetting>

            </SidebarSettingAccordion>





            <SidebarSettingAccordion selectedSetting={false} optionKey="link" parent="cart-settings" title="Link">
                <SidebarElementWrapper>
                    <LinkPicker handleLinkChange={this.handleLinkChange} data={this.props.builder.components[this.props.id]} />
                </SidebarElementWrapper>
            </SidebarSettingAccordion>





			</div>
    	);
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    render() {
    	if(this.props.sidebar == true) {
    		return(
    			<div>
    			
	    		
				{this.props.sidebar ? <SidebarElementHeader handleBackClick={this.handleBackClick} text="Image" />:null}
				{!this.el().isUploading && this.el().image == false ? this.renderUpload():null}
				{this.el().isUploading ? this.renderIsUploading():null}
				{!this.el().isUploading && this.el().image != false ? this.renderSettings():null}
				</div>
    		);
    	}else{
    		return (
	      		<table className="table-block" style={{width:'100%'}}>
                    <tbody>
                        <tr>
                            {this.el().isUploading ? this.renderIsUploading():null}
                            {!this.el().isUploading && this.el().image == false ? this.renderUpload():null}
                            {!this.el().isUploading && this.el().image != false ? this.renderImage():null}
                        </tr>
                    </tbody>
                </table>
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

FileUpload = connect(mapStateToProps,mapDispatchToProps)(FileUpload);

export default FileUpload;





// WEBPACK FOOTER //
// ./components/builder/FileUpload.js